define(function(require) {
	const Utils = require('civicsUtils/general_utilities');

	var buildAddressLine1 = function(mdl) {

		var strNo = mdl.STRNO ? mdl.STRNO : mdl.streetNumber //STRNO from Map, streetNumber from Hansen
		var street = mdl.STRNAME ? mdl.STRNAME : mdl.streetName
		var subDes = mdl.SubDesign ? mdl.SubDesign : mdl.subDesignation

		var locationLine1 = strNo + " "

		if (mdl.PreDir1 && mdl.PreDir1.trim().length > 0) { locationLine1 += mdl.PreDir1 + " " }
		if (mdl.PreDir2 && mdl.PreDir2.trim().length > 0) { locationLine1 += mdl.PreDir2 + " " }
		if (mdl.PreDir3 && mdl.PreDir3.trim().length > 0) { locationLine1 += mdl.PreDir3 + " " }

		locationLine1 += street += " "

		if (mdl.STRTYPE && mdl.STRTYPE.trim().length > 0) { locationLine1 += mdl.STRTYPE + " " }
		if (mdl.Suffix2 && mdl.Suffix2.trim().length > 0) { locationLine1 += mdl.Suffix2 + " " }
		if (mdl.Suffix3 && mdl.Suffix3.trim().length > 0) { locationLine1 += mdl.Suffix3 + " " }

		if (mdl.PostDir1 && mdl.PostDir1.trim().length > 0) { locationLine1 += mdl.PostDir1 + " " }
		if (mdl.PostDir2 && mdl.PostDir2.trim().length > 0) { locationLine1 += mdl.PostDir2 + " " }
		if (mdl.PostDir3 && mdl.PostDir3.trim().length > 0) { locationLine1 += mdl.PostDir3 + " " }

		if (subDes && subDes.trim().length > 0) {
			let locale = Utils.getUserLang();

			if (locale === 'en-CA') {
				 locationLine1 = `${subDes}-${locationLine1}`;
			} else {
				locationLine1 += subDes + " ";
			}
		 }

		return locationLine1.trim();
	}
	var buildAddressLine2 = function(mdl){
		var state = mdl.STATE && mdl.STATE.trim().length>0 ? mdl.STATE : mdl.region //STATE from Map, region from Hansen
		var zip = mdl.ZIP && mdl.ZIP.toString().trim().length > 0? mdl.ZIP : mdl.postalCode //ZIP from map, postalCode from hansen

		var locationLine2 = _.isEmpty(mdl.CITY) ? "" : mdl.CITY;

		if(state && state.trim().length > 0) {
			locationLine2 += " " + state;
		}

		if(zip && zip.toString().trim().length>0) { locationLine2+=" "+mdl.ZIP }

		return locationLine2.trim()
	}

	return {
		//mdl is the json of a site object, be it parcel, address, or coordinates
		buildLocationLine1: function(mdl) {
			if (mdl.locationLine1 && mdl.locationLine1.trim().length > 0) {
				return mdl.locationLine1
			}
			let type = mdl._siteType || mdl.type;
			if (type) {
				switch (type.trim().toLowerCase()) {
					case 'parcel':
						return mdl.parcelId
						break;
					case 'address':
						return buildAddressLine1(mdl)
						break;
					case 'coords':
						return '↔: '+mdl.lon
						break;
					case 'asset':
						return mdl.description != undefined ? mdl.description : mdl.displayText //mdl.description in instrument, mdl.displayText in submit
						break;
					default:
						if (__DEV__) console.log('Incorrect type associated with site model: ', mdl)
						return null;
						break;

				}
			}
			if (__DEV__) console.log('No type associated with site model: ', mdl)
			return null

		},
		buildLocationLine2: function(mdl) {
			if (mdl.locationLine2 && mdl.locationLine2.trim().length > 0) {
				return mdl.locationLine2
			}
			let type = mdl._siteType || mdl.type;
			if (type) {
				switch (type.trim().toLowerCase()) {
					case 'parcel':
						return null;
						break;
					case 'address':
						return buildAddressLine2(mdl)
						break;
					case 'coords':
						return '↕: '+mdl.lat
						break;
					case 'asset':
						return null;
						break;
					default:
						if (__DEV__) console.log('Incorrect type associated with site model: ', mdl)
						return null;
						break;
				}
			}
			if (__DEV__) console.log('No type associated with site model: ', mdl)
			return null

		},
		displayType: function(mdl) {
			let type = mdl._siteType || mdl.type;
			if (type) {
				switch (type.trim().toLowerCase()) {
					case 'parcel':
						return i18n.t('CIVICS.COMMON.PARCEL')
						break;
					case 'address':
						return i18n.t('CIVICS.COMMON.ADDRESS')
						break;
					case 'coords':
						return i18n.t('CIVICS.COMMON.COORDINATES')
						break;
					case 'asset':
						return mdl.typeDisplayText		//ie: "Street Sign", "Water Main", "Building"
						break;
					default:
						if (__DEV__) console.log('Incorrect type associated with site model: ', mdl)
						return null;
						break;

				}
			} else {
				if (__DEV__) console.log('No type associated with site model: ', mdl)
				return null
			}
		}
	}
});
